import { Logger, Module, removeItemFromArray } from '@nu-art/ts-common';
export const Key_UndefinedMessage = 'undefined-message';
class ModuleFE_WindowMessenger_Class extends Module {
    //######################### Static #########################
    receivers = [];
    listener;
    //######################### Life Cycle #########################
    addReceiver(receiver) {
        if (this.receivers.includes(receiver))
            return;
        this.receivers.push(receiver);
        if (this.receivers.length > 0 && !this.listener)
            window.addEventListener('message', this.listener = (e) => {
                const { data, origin } = e;
                this.receivers.forEach(receiver => receiver.execute(origin, data));
            });
    }
    removeReceiver(receiver) {
        removeItemFromArray(this.receivers, receiver);
        if (this.receivers.length === 0) {
            window.removeEventListener('message', this.listener);
            delete this.listener;
        }
    }
    sendMessage(message, target) {
        target.postMessage(message, '*');
    }
    createMessenger(target) {
        return new Messenger(target);
    }
    createReceiver(origin, transformer) {
        return new Receiver(origin, transformer);
    }
    createRawReceiver(execute, origin) {
        return new RawReceiver(execute, origin);
    }
}
export const ModuleFE_WindowMessenger = new ModuleFE_WindowMessenger_Class();
//Message Sender
export class Messenger {
    target;
    constructor(target) {
        this.target = target;
    }
    sendMessage(message) {
        ModuleFE_WindowMessenger.sendMessage(message, this.target);
    }
}
//Message Receiver
export class BaseReceiver extends Logger {
    origin;
    regex;
    filter = (message) => true;
    constructor(origin = '.*') {
        super();
        this.setTag(`Receiver (${origin})`);
        this.origin = origin;
        this.regex = new RegExp(origin);
    }
    mount() {
        ModuleFE_WindowMessenger.addReceiver(this);
        return this;
    }
    unmount() {
        ModuleFE_WindowMessenger.removeReceiver(this);
        return this;
    }
    execute = (origin, message) => {
        if (!this.regex.test(origin))
            return;
        if (!this.filter(message))
            return;
        this.executeImpl(message);
    };
    setFilter(filter) {
        this.filter = filter;
        return this;
    }
}
export class RawReceiver extends BaseReceiver {
    execute;
    constructor(execute, origin = '.*') {
        super(origin);
        this.execute = execute;
    }
    executeImpl(message) {
        this.execute(message);
    }
}
/**
 * Need to add a processor per each key prop's value that can be returned in the transformer output.
 */
export class Receiver extends BaseReceiver {
    messageProcessorMap = {};
    transform; // Receives one window message, returns array with 1 or more transformed messages., each message needs prop 'key' with a matching processor added.
    defaultProcessor;
    /**
     *
     * @param origin window.origin
     * @param transform Receives the MessageEvent and needs to transform it into an array of objects, each having prop "key". To each potential "key", you need to add an appropriate processor.
     */
    constructor(origin = '.*', transform = data => [data]) {
        super();
        this.setTag(`Receiver (${origin})`);
        this.transform = transform;
    }
    setDefaultProcessor(processor) {
        this.defaultProcessor = processor;
        return this;
    }
    addProcessor(key, processor) {
        this.messageProcessorMap[key] = processor;
        return this;
    }
    executeImpl(message) {
        const transformedMessages = this.transform(message);
        transformedMessages.forEach(_transformedMessage => {
            const processor = this.messageProcessorMap[_transformedMessage.key];
            if (processor) {
                processor(_transformedMessage);
                return;
            }
            this.logDebug(`No message processor defined for key ${message.key}`);
            this.defaultProcessor?.(_transformedMessage, message);
            return;
        });
    }
}
//# sourceMappingURL=ModuleFE_WindowMessenger.js.map